import React, { useState, useEffect } from "react";
import "./App.css";
import Login from "./Login";
import CrearAnuncio from "./CrearAnuncio";
import VistaUsuarios from "./VistaUsuarios";
import PanelAdmin from "./PanelAdmin";
import MisAnuncios from "./MisAnuncios";

function App() {
  const [anuncios, setAnuncios] = useState([]);
  const [perfilIndex, setPerfilIndex] = useState(0);
  const [fotoIndex, setFotoIndex] = useState(0);
  const [cargando, setCargando] = useState(true);

  // Estados para Likes del anuncio actual
  const [totalLikes, setTotalLikes] = useState(0);
  const [userLiked, setUserLiked] = useState(false);

  // Estado de seguridad de mayoría de edad (+18)
  const [edadVerificada, setEdadVerificada] = useState(() => {
    return localStorage.getItem("edad_verificada") === "true";
  });

  // Estados para Swipe Táctil
  const [touchStartY, setTouchStartY] = useState(0);

  // Estados para modales y avisos
  const [mensajeLimiteDias, setMensajeLimiteDias] = useState("");
  const [mostrarModalLimiteDias, setMostrarModalLimiteDias] = useState(false);
  const [mostrarModalConfirmarEliminar, setMostrarModalConfirmarEliminar] =
    useState(false);

  // Modales y vistas
  const [mostrarAuthForm, setMostrarAuthForm] = useState(false);
  const [mostrarFormPublicar, setMostrarFormPublicar] = useState(false);
  const [mostrarModalDetalles, setMostrarModalDetalles] = useState(false);
  const [mostrarModalTerminos, setMostrarModalTerminos] = useState(false);
  const [mostrarModalPerfil, setMostrarModalPerfil] = useState(false);
  const [mostrarModalAvisoPublicar, setMostrarModalAvisoPublicar] =
    useState(false);
  const [mostrarModalAvisoEliminado, setMostrarModalAvisoEliminado] =
    useState(false);
  const [mostrarModalAvisoLike, setMostrarModalAvisoLike] = useState(false);

  const [terminosLeidos, setTerminosLeidos] = useState(false);
  const [aceptoPoliticas, setAceptoPoliticas] = useState(false);

  // Estado del usuario logueado
  const [esModoLogin, setEsModoLogin] = useState(false);
  const [usuarioLogueado, setUsuarioLogueado] = useState(() => {
    const sesionGuardada = localStorage.getItem("usuario_sesion");
    return sesionGuardada ? JSON.parse(sesionGuardada) : null;
  });

  // Formulario Auth
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    password: "",
  });
  const [carnetAnverso, setCarnetAnverso] = useState(null);
  const [carnetReverso, setCarnetReverso] = useState(null);

  const [mostrarVistaGrid, setMostrarVistaGrid] = useState(false);
  const [mostrarPanelAdmin, setMostrarPanelAdmin] = useState(false);
  const [mostrarMisAnuncios, setMostrarMisAnuncios] = useState(false);

  const cerrarSesion = () => {
    localStorage.removeItem("usuario_sesion");
    setUsuarioLogueado(null);
    setMostrarModalPerfil(false);
  };

  const cargarAnunciosBD = async () => {
    try {
      const userIdParam = usuarioLogueado
        ? `?user_id=${usuarioLogueado.id}`
        : "";
      const res = await fetch(
        `https://micontenidohot.com/obtener_anuncios.php${userIdParam}`
      );
      const data = await res.json();
      if (data.success && data.anuncios.length > 0) {
        setAnuncios(data.anuncios);
      } else {
        setAnuncios([]);
      }
    } catch (err) {
      console.error("Error cargando anuncios:", err);
    } finally {
      setCargando(false);
    }
  };

  // Recargar anuncios cuando cambia el usuario logueado o al iniciar
  useEffect(() => {
    cargarAnunciosBD();
  }, [usuarioLogueado]);

  // Sincronizar likes del anuncio actual de forma reactiva
  useEffect(() => {
    if (anuncios.length > 0 && anuncios[perfilIndex]) {
      const actual = anuncios[perfilIndex];
      setTotalLikes(Number(actual.total_likes) || 0);
      setUserLiked(Boolean(actual.user_liked));
    }
  }, [perfilIndex, anuncios]);

  const manejarClickLike = async () => {
    if (!usuarioLogueado) {
      setMostrarModalAvisoLike(true);
      return;
    }

    const perfilActual = anuncios[perfilIndex];
    if (!perfilActual) return;

    try {
      const res = await fetch("https://micontenidohot.com/dar_like.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          anuncio_id: perfilActual.id,
          user_id: usuarioLogueado.id,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setTotalLikes(data.total_likes);
        setUserLiked(true); // Pinta el corazón instantáneamente de rosado

        // Actualizamos también el array local para mantener consistencia
        setAnuncios((prev) =>
          prev.map((item, idx) => {
            if (idx === perfilIndex) {
              return {
                ...item,
                total_likes: data.total_likes,
                user_liked: true,
              };
            }
            return item;
          })
        );
      }
    } catch (err) {
      console.error("Error al dar like:", err);
    }
  };

  const abrirTerminosYHabilitar = () => {
    setTerminosLeidos(true);
    setMostrarModalTerminos(true);
  };

  const cerrarYAceptarTerminos = () => {
    setMostrarModalTerminos(false);
    setTerminosLeidos(true);
    setAceptoPoliticas(true);
  };

  if (mostrarPanelAdmin && usuarioLogueado?.rol === "admin") {
    return (
      <div
        className="index-page-wrapper"
        style={{ overflowY: "auto", padding: "20px 0" }}
      >
        <PanelAdmin
          alVolver={() => setMostrarPanelAdmin(false)}
          alCerrarSesion={() => {
            cerrarSesion();
            setMostrarPanelAdmin(false);
          }}
        />
      </div>
    );
  }

  if (mostrarVistaGrid) {
    return <VistaUsuarios alVolver={() => setMostrarVistaGrid(false)} />;
  }

  if (mostrarMisAnuncios && usuarioLogueado) {
    return (
      <div
        className="index-page-wrapper"
        style={{ overflowY: "auto", padding: "20px 0" }}
      >
        <MisAnuncios
          usuario={usuarioLogueado}
          alVolver={() => setMostrarMisAnuncios(false)}
        />
      </div>
    );
  }

  const siguientePerfil = () => {
    if (anuncios.length > 0) {
      setPerfilIndex((prev) => (prev + 1) % anuncios.length);
      setFotoIndex(0);
    }
  };

  const anteriorPerfil = () => {
    if (anuncios.length > 0) {
      setPerfilIndex((prev) => (prev - 1 + anuncios.length) % anuncios.length);
      setFotoIndex(0);
    }
  };

  const handleTouchStart = (e) => {
    setTouchStartY(e.touches[0].clientY);
  };

  const handleTouchEnd = (e) => {
    const touchEndY = e.changedTouches[0].clientY;
    const diffY = touchStartY - touchEndY;

    if (diffY > 50) {
      siguientePerfil();
    } else if (diffY < -50) {
      anteriorPerfil();
    }
  };

  const clickMisAnuncios = () => {
    setMostrarMisAnuncios(true);
  };

  const clickPublicar = async () => {
    if (!usuarioLogueado) {
      setMostrarAuthForm(true);
      return;
    }

    if (usuarioLogueado.estado_verificacion !== "aprobado") {
      setMostrarModalAvisoPublicar(true);
      return;
    }

    try {
      const res = await fetch(
        `https://micontenidohot.com/obtener_anuncios.php?user_id=${usuarioLogueado.id}`
      );
      const data = await res.json();

      if (data.success && data.anuncios && data.anuncios.length > 0) {
        const anuncioExistente = data.anuncios.find(
          (a) => String(a.user_id) === String(usuarioLogueado.id)
        );

        if (anuncioExistente) {
          if (anuncioExistente.status === "pendiente") {
            setMensajeLimiteDias(
              "Tienes un anuncio registrado pendiente de pago o confirmación de soporte. Puedes eliminarlo desde 'Detalles' para crear uno nuevo."
            );
            setMostrarModalLimiteDias(true);
            return;
          }

          if (anuncioExistente.status === "activo") {
            const fechaReferencia = new Date(
              anuncioExistente.fecha_aprobacion || anuncioExistente.created_at
            );
            const diasPlan = anuncioExistente.plan === "semana" ? 7 : 30;
            const fechaExpiracion = new Date(fechaReferencia);
            fechaExpiracion.setDate(fechaExpiracion.getDate() + diasPlan);

            const hoy = new Date();
            const diferenciaTiempo = fechaExpiracion - hoy;
            const diasFaltantes = Math.ceil(
              diferenciaTiempo / (1000 * 60 * 60 * 24)
            );
            const fechaFormateada = fechaReferencia.toLocaleDateString();

            if (diasFaltantes > 0) {
              setMensajeLimiteDias(
                `Ya tienes un anuncio activo desde (${fechaFormateada}). Te faltan ${diasFaltantes} días de vigencia para publicar otro.`
              );
              setMostrarModalLimiteDias(true);
              return;
            }
          }
        }
      }

      setMostrarFormPublicar(true);
    } catch (err) {
      console.error("Error al verificar anuncios:", err);
    }
  };

  const clickPerfil = () => {
    if (!usuarioLogueado) {
      setMostrarAuthForm(true);
    } else {
      setMostrarModalPerfil(true);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const manejarSubmit = async (e) => {
    e.preventDefault();

    if (esModoLogin) {
      try {
        const res = await fetch(
          "https://micontenidohot.com/procesar_login.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: formData.email,
              password: formData.password,
            }),
          }
        );
        const data = await res.json();
        if (data.success) {
          localStorage.setItem("usuario_sesion", JSON.stringify(data.usuario));
          setUsuarioLogueado(data.usuario);
          setMostrarAuthForm(false);
        } else {
          alert(data.mensaje);
        }
      } catch (err) {
        alert("Error conectando con el servidor PHP");
      }
    } else {
      if (!aceptoPoliticas) {
        alert("Debes leer y aceptar los términos y condiciones.");
        return;
      }

      const data = new FormData();
      data.append("nombre", formData.nombre);
      data.append("email", formData.email);
      data.append("password", formData.password);
      if (carnetAnverso) data.append("carnet_anverso", carnetAnverso);
      if (carnetReverso) data.append("carnet_reverso", carnetReverso);

      try {
        const res = await fetch("https://micontenidohot.com/registro.php", {
          method: "POST",
          body: data,
        });
        const resData = await res.json();
        if (resData.success) {
          alert(resData.mensaje);
          setEsModoLogin(true);
        } else {
          alert(resData.mensaje);
        }
      } catch (err) {
        alert("Error de conexión al registrar usuario");
      }
    }
  };

  const perfilActual = anuncios[perfilIndex];

  const fotosAnuncio = perfilActual
    ? Array.isArray(perfilActual.fotos) && perfilActual.fotos.length > 0
      ? perfilActual.fotos
      : [perfilActual.imagen]
    : [];

  const cambiarFotoManual = (direccion) => {
    if (fotosAnuncio.length <= 1) return;
    if (direccion === "next") {
      setFotoIndex((prev) => (prev + 1) % fotosAnuncio.length);
    } else {
      setFotoIndex(
        (prev) => (prev - 1 + fotosAnuncio.length) % fotosAnuncio.length
      );
    }
  };

  if (mostrarFormPublicar && usuarioLogueado) {
    return (
      <div
        className="index-page-wrapper"
        style={{ overflowY: "auto", padding: "20px 0" }}
      >
        <CrearAnuncio
          usuario={usuarioLogueado}
          alVolver={() => setMostrarFormPublicar(false)}
          alCompletar={() => {
            setMostrarFormPublicar(false);
            cargarAnunciosBD();
          }}
        />
      </div>
    );
  }

  return (
    <div
      className="shorts-container"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {mostrarAuthForm && (
        <Login
          esModoLogin={esModoLogin}
          setEsModoLogin={setEsModoLogin}
          formData={formData}
          handleChange={handleChange}
          manejarSubmit={manejarSubmit}
          carnetAnverso={carnetAnverso}
          setCarnetAnverso={setCarnetAnverso}
          carnetReverso={carnetReverso}
          setCarnetReverso={setCarnetReverso}
          aceptoPoliticas={aceptoPoliticas}
          setAceptoPoliticas={setAceptoPoliticas}
          terminosLeidos={terminosLeidos}
          abrirTerminosYHabilitar={abrirTerminosYHabilitar}
          setMostrarAuthForm={setMostrarAuthForm}
          mostrarModalTerminos={mostrarModalTerminos}
          setMostrarModalTerminos={setMostrarModalTerminos}
          cerrarYAceptarTerminos={cerrarYAceptarTerminos}
        />
      )}

      {!edadVerificada && (
        <div
          className="modal-overlay"
          style={{
            backdropFilter: "blur(25px)",
            background: "rgba(0, 0, 0, 0.9)",
          }}
        >
          <div
            className="modal-content"
            style={{
              textAlign: "center",
              maxWidth: "380px",
              padding: "30px 24px",
            }}
          >
            <div style={{ fontSize: "2.8rem", marginBottom: "10px" }}>🔞</div>
            <h3
              style={{
                color: "#0f172a",
                fontSize: "1.4rem",
                fontWeight: "800",
                marginBottom: "10px",
              }}
            >
              Control de Acceso +18
            </h3>
            <p
              style={{
                color: "#475569",
                fontSize: "0.88rem",
                lineHeight: "1.5",
                marginBottom: "20px",
              }}
            >
              Este sitio web contiene material explícito y anuncios de servicios
              para adultos. Es estrictamente para **mayores de 18 años**.
            </p>

            <button
              onClick={() => {
                setEdadVerificada(true);
                localStorage.setItem("edad_verificada", "true");
              }}
              className="btn-create-account"
              style={{ width: "100%", marginBottom: "12px", padding: "14px" }}
            >
              Soy mayor de 18 años (Ingresar)
            </button>

            <a
              href="https://www.google.com"
              style={{
                fontSize: "0.8rem",
                color: "#94a3b8",
                textDecoration: "underline",
                fontWeight: "600",
              }}
            >
              Salir de la página
            </a>
          </div>
        </div>
      )}

      {cargando ? (
        <div style={{ color: "#fff", fontSize: "1rem" }}>
          Cargando anuncios...
        </div>
      ) : perfilActual ? (
        <div
          className="short-screen"
          style={{
            backgroundImage: `url(${
              fotosAnuncio[fotoIndex] || perfilActual.imagen
            })`,
            filter: !edadVerificada ? "blur(20px)" : "none",
            transition: "filter 0.4s ease",
          }}
        >
          {fotosAnuncio.length > 1 && (
            <div
              style={{
                position: "absolute",
                top: "12px",
                left: "14px",
                right: "14px",
                zIndex: 10,
                display: "flex",
                gap: "6px",
              }}
            >
              {fotosAnuncio.map((_, idx) => (
                <div
                  key={idx}
                  style={{
                    flex: 1,
                    height: "2px",
                    backgroundColor:
                      idx === fotoIndex ? "#ff2c55" : "rgba(255,255,255,0.35)",
                    borderRadius: "2px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.5)",
                    transition: "all 0.3s ease",
                  }}
                />
              ))}
            </div>
          )}

          {fotosAnuncio.length > 1 && (
            <>
              <div
                onClick={() => cambiarFotoManual("prev")}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "30%",
                  height: "80%",
                  zIndex: 4,
                }}
              />
              <div
                onClick={() => cambiarFotoManual("next")}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "30%",
                  height: "80%",
                  zIndex: 4,
                }}
              />
            </>
          )}

          <header className="shorts-top-bar">
            <div className="top-left-brand">
              <img
                src="/logo.png"
                alt="Logo"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "contain",
                }}
              />
              <h1 className="brand-header-text">
                <span></span>
                <span></span>
              </h1>
            </div>
          </header>

          <div className="shorts-sidebar">
            <button className="side-action-item" onClick={manejarClickLike}>
              <span
                style={{
                  fontSize: "0.75rem",
                  fontWeight: "700",
                  marginBottom: "2px",
                  color: "#fff",
                }}
              >
                {totalLikes}
              </span>
              <div className="side-icon-circle">
                <svg
                  viewBox="0 0 24 24"
                  fill={userLiked ? "#ffffff" : "none"}
                  stroke="#ffffff"
                  strokeWidth="2"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </div>
              <span>Me gusta</span>
            </button>

            <button
              className="side-action-item"
              onClick={() => setMostrarVistaGrid(true)}
            >
              <div className="side-icon-circle">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
              <span>Buscar</span>
            </button>

            <button
              className="side-action-item"
              onClick={() => setMostrarModalDetalles(true)}
            >
              <div className="side-icon-circle">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
              </div>
              <span>Detalles</span>
            </button>

            {usuarioLogueado && (
              <button className="side-action-item" onClick={clickMisAnuncios}>
                <div className="side-icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="12" y1="18" x2="12" y2="12"></line>
                  </svg>
                </div>
                <span>Mis Anuncios</span>
              </button>
            )}

            <button className="side-action-item" onClick={clickPublicar}>
              <div className="side-icon-circle highlight-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>
              <span>Publicar</span>
            </button>

            <button className="side-action-item" onClick={clickPerfil}>
              <div className="side-icon-circle user-avatar-circle">
                {usuarioLogueado ? (
                  <span className="user-initial-avatar">
                    {usuarioLogueado.nombre.charAt(0).toUpperCase()}
                  </span>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                )}
              </div>
              <span>
                {usuarioLogueado
                  ? usuarioLogueado.nombre.split(" ")[0]
                  : "Mi Perfil"}
              </span>
            </button>
          </div>

          <div className="shorts-bottom-info">
            <div className="user-meta">
              <h2>
                {perfilActual.nic}, {perfilActual.edad}{" "}
                <span className="verified-badge-short">✓</span>
              </h2>
            </div>
            <p className="location-text">
              <svg className="location-icon" viewBox="0 0 24 24">
                <path
                  fill="#ef4444"
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              </svg>
              {perfilActual.ubicacion}, {perfilActual.pais || "Bolivia"}
            </p>

            <div className="tags-row-short">
              {perfilActual.servicios.map((tag, idx) => (
                <span key={idx} className="tag-short">
                  {tag.trim()}
                </span>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            color: "#fff",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: "14px",
            padding: "20px",
          }}
        >
          <h3>No hay anuncios creados aún.</h3>

          <button onClick={clickPublicar} className="btn-create-account">
            Sé el primero en publicar
          </button>

          {usuarioLogueado?.rol === "admin" ? (
            <button
              onClick={() => setMostrarPanelAdmin(true)}
              className="btn-create-account"
              style={{ background: "#0f172a", border: "1px solid #334155" }}
            >
              ⚙️ Ir al Panel de Control Admin
            </button>
          ) : (
            <button onClick={clickPerfil} className="btn-back-main">
              {usuarioLogueado ? "Ver Mi Perfil" : "Iniciar Sesión"}
            </button>
          )}
        </div>
      )}

      {/* MODAL MI PERFIL */}
      {mostrarModalPerfil && usuarioLogueado && (
        <div className="modal-overlay">
          <div className="modal-content profile-modal-card">
            <div className="profile-header-modal">
              <div className="big-avatar">
                {usuarioLogueado.nombre.charAt(0).toUpperCase()}
              </div>
              <h3>{usuarioLogueado.nombre}</h3>
              <p className="profile-email">{usuarioLogueado.email}</p>
            </div>

            <div className="profile-details-list">
              <div className="profile-detail-item">
                <span>Tipo de cuenta:</span>
                <strong>{usuarioLogueado.rol.toUpperCase()}</strong>
              </div>

              <div className="profile-detail-item">
                <span>Estado de Verificación:</span>
                <span
                  className={`status-badge status-${usuarioLogueado.estado_verificacion}`}
                >
                  {usuarioLogueado.estado_verificacion === "pendiente" &&
                    "⏳ Pendiente"}
                  {usuarioLogueado.estado_verificacion === "aprobado" &&
                    "✅ Verificado"}
                  {usuarioLogueado.estado_verificacion === "rechazado" &&
                    "❌ Rechazado"}
                </span>
              </div>
            </div>

            {usuarioLogueado.rol === "admin" && (
              <button
                onClick={() => {
                  setMostrarPanelAdmin(true);
                  setMostrarModalPerfil(false);
                }}
                className="btn-create-account"
                style={{
                  width: "100%",
                  marginTop: "14px",
                  background: "#0f172a",
                }}
              >
                ⚙️ Ir al Panel de Control
              </button>
            )}

            <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
              <button
                onClick={() => setMostrarModalPerfil(false)}
                className="btn-login-clean"
                style={{ flex: 1, padding: "10px" }}
              >
                Cerrar
              </button>
              <button
                onClick={cerrarSesion}
                className="btn-create-account"
                style={{ flex: 1, padding: "10px", background: "#e11d48" }}
              >
                Salir
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DETALLES */}
      {mostrarModalDetalles && perfilActual && (
        <div
          className="modal-overlay"
          onClick={() => setMostrarModalDetalles(false)}
          onTouchStart={(e) => e.stopPropagation()}
          onTouchEnd={(e) => e.stopPropagation()}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "420px",
              width: "100%",
              background: "#ffffff",
              borderRadius: "24px",
              padding: "24px",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
              border: "1px solid #f1f5f9",
              maxHeight: "85vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                borderBottom: "1px solid #f1f5f9",
                paddingBottom: "14px",
                marginBottom: "16px",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: 0,
                    color: "#0f172a",
                    fontSize: "1.25rem",
                    fontWeight: "800",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {perfilActual.nic}
                  <span
                    style={{
                      color: "#64748b",
                      fontWeight: "400",
                      fontSize: "0.9rem",
                    }}
                  >
                    ({perfilActual.edad} años)
                  </span>
                </h3>
                <p
                  style={{
                    margin: "6px 0 0 0",
                    fontSize: "0.82rem",
                    color: "#64748b",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#64748b"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    {perfilActual.ubicacion}
                  </span>
                </p>
              </div>
            </div>

            {fotosAnuncio.length > 0 && (
              <div style={{ marginBottom: "16px" }}>
                <h4
                  style={{
                    fontSize: "0.72rem",
                    color: "#94a3b8",
                    textTransform: "uppercase",
                    marginBottom: "8px",
                    letterSpacing: "0.5px",
                    fontWeight: "700",
                  }}
                >
                  Galería de Fotos
                </h4>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    overflowX: "auto",
                    paddingBottom: "4px",
                  }}
                >
                  {fotosAnuncio.map((fotoUrl, idx) => (
                    <img
                      key={idx}
                      src={fotoUrl}
                      alt="Foto anuncio"
                      style={{
                        width: "64px",
                        height: "64px",
                        objectFit: "cover",
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        flexShrink: 0,
                      }}
                    />
                  ))}
                </div>
              </div>
            )}

            {perfilActual.servicios && perfilActual.servicios.length > 0 && (
              <div style={{ marginBottom: "16px" }}>
                <h4
                  style={{
                    fontSize: "0.72rem",
                    color: "#94a3b8",
                    textTransform: "uppercase",
                    marginBottom: "8px",
                    letterSpacing: "0.5px",
                    fontWeight: "700",
                  }}
                >
                  Tipo de Servicios
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {perfilActual.servicios.map((serv, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: "#f8fafc",
                        color: "#334155",
                        padding: "5px 10px",
                        borderRadius: "10px",
                        fontSize: "0.75rem",
                        fontWeight: "600",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      {serv.trim()}
                    </span>
                  ))}
                </div>
              </div>
            )}

            <div style={{ marginBottom: "20px" }}>
              <h4
                style={{
                  fontSize: "0.72rem",
                  color: "#94a3b8",
                  textTransform: "uppercase",
                  marginBottom: "8px",
                  letterSpacing: "0.5px",
                  fontWeight: "700",
                }}
              >
                Descripción
              </h4>
              <p
                style={{
                  fontSize: "0.82rem",
                  color: "#334155",
                  lineHeight: "1.5",
                  background: "#f8fafc",
                  padding: "12px",
                  borderRadius: "14px",
                  margin: 0,
                  border: "1px solid #e2e8f0",
                }}
              >
                {perfilActual.descripcion || "Sin descripción disponible."}
              </p>
            </div>

            <a
              href={`https://wa.me/${perfilActual.telefono?.replace(
                /\D/g,
                ""
              )}?text=Hola%20${encodeURIComponent(
                perfilActual.nic
              )},%20vi%20tu%20perfil%20y%20me%20interesa%20más%20información.`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                width: "100%",
                background: "#25D366",
                color: "#fff",
                padding: "12px",
                borderRadius: "16px",
                textDecoration: "none",
                fontWeight: "700",
                fontSize: "0.88rem",
                marginBottom: "10px",
                boxShadow: "0 4px 12px rgba(37, 211, 102, 0.25)",
              }}
            >
              Contactar por WhatsApp
            </a>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setMostrarModalDetalles(false);
              }}
              style={{
                width: "100%",
                background: "#0f172a",
                color: "#fff",
                padding: "12px",
                borderRadius: "16px",
                border: "none",
                cursor: "pointer",
                fontWeight: "700",
                fontSize: "0.88rem",
              }}
            >
              Cerrar ventana
            </button>
          </div>
        </div>
      )}

      {/* MODAL LÍMITE DE DÍAS */}
      {mostrarModalLimiteDias && (
        <div
          className="modal-overlay"
          onClick={() => setMostrarModalLimiteDias(false)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ textAlign: "center", maxWidth: "380px" }}
          >
            <div
              style={{
                width: "54px",
                height: "54px",
                borderRadius: "50%",
                backgroundColor: "#fff1f2",
                color: "#ff2c55",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 14px auto",
                fontSize: "1.5rem",
                fontWeight: "bold",
                border: "1px solid #fecdd3",
              }}
            >
              ⚠️
            </div>
            <h3
              style={{
                color: "#0f172a",
                fontSize: "1.15rem",
                marginBottom: "8px",
                fontWeight: "800",
              }}
            >
              Límite de Publicación
            </h3>
            <p className="modal-body" style={{ marginBottom: "20px" }}>
              {mensajeLimiteDias}
            </p>
            <button
              onClick={() => setMostrarModalLimiteDias(false)}
              className="btn-create-account"
              style={{ width: "100%", padding: "12px" }}
            >
              Aceptar
            </button>
          </div>
        </div>
      )}
      {/* MODAL AVISO CUENTA PENDIENTE DE APROBACIÓN */}
      {mostrarModalAvisoPublicar && (
        <div
          className="modal-overlay"
          onClick={() => setMostrarModalAvisoPublicar(false)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ textAlign: "center", maxWidth: "380px" }}
          >
            <div
              style={{
                width: "54px",
                height: "54px",
                borderRadius: "50%",
                backgroundColor: "#fffbeb",
                color: "#d97706",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 14px auto",
                fontSize: "1.5rem",
                fontWeight: "bold",
                border: "1px solid #fef3c7",
              }}
            >
              ⏳
            </div>
            <h3
              style={{
                color: "#0f172a",
                fontSize: "1.15rem",
                marginBottom: "8px",
                fontWeight: "800",
              }}
            >
              Cuenta en revisión
            </h3>
            <p className="modal-body" style={{ marginBottom: "20px" }}>
              Tu cuenta se encuentra en estado <strong>pendiente</strong> de
              aprobación. Debes esperar a que el equipo de soporte apruebe tu
              cuenta para poder publicar un anuncio.
            </p>
            <button
              onClick={() => setMostrarModalAvisoPublicar(false)}
              className="btn-create-account"
              style={{ width: "100%", padding: "12px" }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}

      {/* MODAL AVISO LIKE SIN REGISTRO */}
      {mostrarModalAvisoLike && (
        <div
          className="modal-overlay"
          onClick={() => setMostrarModalAvisoLike(false)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ textAlign: "center", maxWidth: "380px" }}
          >
            <div
              style={{
                width: "54px",
                height: "54px",
                borderRadius: "50%",
                backgroundColor: "#fff1f2",
                color: "#ff2c55",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 14px auto",
                fontSize: "1.5rem",
                fontWeight: "bold",
                border: "1px solid #fecdd3",
              }}
            >
              ❤️
            </div>
            <h3
              style={{
                color: "#0f172a",
                fontSize: "1.15rem",
                marginBottom: "8px",
                fontWeight: "800",
              }}
            >
              ¡Inicia sesión para continuar!
            </h3>
            <p className="modal-body" style={{ marginBottom: "20px" }}>
              Para dar "Me gusta" a los anuncios, debes registrarte o iniciar
              sesión.
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={() => setMostrarModalAvisoLike(false)}
                className="btn-login-clean"
                style={{ flex: 1, padding: "12px" }}
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  setMostrarModalAvisoLike(false);
                  setEsModoLogin(true);
                  setMostrarAuthForm(true);
                }}
                className="btn-create-account"
                style={{ flex: 1, padding: "12px", boxShadow: "none" }}
              >
                Registrarme
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
